import React from 'react'
import { FormattedMessage } from 'react-intl'
import { toast } from 'react-toastify' // TODO: Import this from lib/ui
import { Alert } from 'lib/ui'
import { Failure } from 'lib/ui/components/Toast/components/Failure'
import { usePaypalExpress } from 'lib/core/hooks/usePaypalExpress'
import { usePaymentMethod } from 'lib/modules/checkout'

export const PaypalExpress = () => {
  const { authorizeUser, error } = usePaypalExpress()

  if (error) {
    toast(() => (
      <Failure
        messageId='checkout.placeOrder.transactionDeclined'
      />
    ), {
      autoClose: 15000
    })
  }

  usePaymentMethod(() => {
    authorizeUser().catch(() => {
      toast(() => (
        <Failure
          messageId='app.whoops'
        />
      ), {
        autoClose: 15000
      })
    })
  })

  if (error) {
    return (
      <Alert type='danger'>
        <FormattedMessage
          id='app.whoops'
        />
      </Alert>
    )
  }

  return null
}
